const normalizeTriggerItemId = (value) => {
  const normalized = String(value || '').trim();
  return normalized || null;
};

export default normalizeTriggerItemId;
